export type IconButtonProps = {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    icon: string;
    title?: string;
};

export const IconButton = ({ icon, onClick, title }: IconButtonProps) => (
    <button type="button" className="btn btn-link btn-icon-toggle" onClick={onClick} title={title}>
        <i className={icon} />
    </button>
);
